import { PDFDocument, rgb } from "pdf-lib";
import { numberWithCommas } from "../helpers/numberConverter";
import fontkit from "@pdf-lib/fontkit";
import PdfCreator from "./PdfCreator";
import UserMasConfirm from "../../entities/UserMasConfirm";
import { pdfDateFormatter } from "../helpers/dateFormatter";
import AssistantFont from "../../assets/fonts/Assistant.ttf";
import pdfTemplate from "../../assets/pdf/masConfirm.pdf";
import amitimLogo from "../../assets/images/Amitim_Logo_Tagline_RGB.png"; 
import mivtahimLogo from "../../assets/fundLogos/001.png";
import kagamLogo from "../../assets/fundLogos/002.png";
import makefetLogo from "../../assets/fundLogos/003.png";
import nativLogo from "../../assets/fundLogos/004.png";
import poalimLogo from "../../assets/fundLogos/005.png";
import haklaimLogo from "../../assets/fundLogos/006.png";
import kagaLogo from "../../assets/fundLogos/007.png";
import hadasaLogo from "../../assets/fundLogos/008.png";

function getFundLogo(fundCode: string) {
  switch (fundCode) {
    case "001":
      return mivtahimLogo;
    case "002":
      return kagamLogo;
    case "003":
      return makefetLogo;
    case "004":
      return nativLogo;
    case "005":
      return poalimLogo;
    case "006":
      return haklaimLogo;
    case "007":
      return kagaLogo;
    case "008":
      return hadasaLogo;
  }
}

async function PdfTemplateCreator(data: UserMasConfirm) {
  if (data) {
    const existingPdfBytes = await fetch(pdfTemplate).then((res) =>
      res.arrayBuffer()
    );

    const amitimLogoBytes = await fetch(amitimLogo).then((res) =>
      res.arrayBuffer()
    );
    const fundLogo =  await getFundLogo(data.fundcode.trim());
    const fundLogoBytes = await fetch(fundLogo ? fundLogo : mivtahimLogo).then((res) =>
    res.arrayBuffer()
    );
    const AssistantBytes = await fetch(AssistantFont).then(
      (
        res //assistantBytes
      ) => res.arrayBuffer()
    );
    // Load a PDFDocument from the existing PDF bytes
    const pdfDoc = await PDFDocument.load(existingPdfBytes);
    // const viewsPrefs = pdfDoc.catalog.getOrCreateViewerPreferences();
    // viewsPrefs.setReadingDirection(ReadingDirection.R2L);
    // console.log(viewsPrefs.getReadingDirection());
    const amitimLogoPng = await pdfDoc.embedPng(amitimLogoBytes);
    const pages = pdfDoc.getPages();
    const firstPage = pages[0];
    const pageWidth = firstPage.getWidth();
    const pageHeight = firstPage.getHeight();
    const imgHeight = 45; // amitimLogoPng.height
    const imgWidth = 100; // amitimLogoPng.height
    const marginX = 50;
    firstPage.drawImage(amitimLogoPng, {
      x: pageWidth - marginX - imgWidth,
      y: pageHeight - marginX - imgHeight,
      width: imgWidth + 10,
      height: imgHeight - 10,
    });

    const fundLogoJpg = await pdfDoc.embedPng(fundLogoBytes);
    // const jpgHeight = fundLogoJpg.height;
    // const jpgWidth = fundLogoJpg.width;
    firstPage.drawImage(fundLogoJpg, {
      x: 50,
      y: pageHeight - marginX - imgHeight, // 753
      width: imgWidth + 35,
      height: imgHeight + 5,
    });

    pdfDoc.registerFontkit(fontkit);
    const assistantFont = await pdfDoc.embedFont(AssistantBytes);

    const form = pdfDoc.getForm();
    const name1Field = form.getTextField("amitName1");
    const accountNumberField = form.getTextField("accountNumber");
    const nikuiNumberField = form.getTextField("nikuiNumber");
    const amitId1Field = form.getTextField("amitId1");
    const fundName1Field = form.getTextField("fundName1");
    const untilDate = form.getTextField("untilDate");
    const fill_5Field = form.getTextField("fill_5"); //unused field?
    const fill_1Field = form.getTextField("fill_1");
    const fill_2Field = form.getTextField("fill_2");

    const yearDoc = form.getTextField("yearDoc");
    const name2Field = form.getTextField("amitName2");
    const policesNumberField = form.getTextField("policesNumber");
    const amitId2Field = form.getTextField("amitId2");
    const fundName2Field = form.getTextField("fundName2");
    const fill_4Field = form.getTextField("fill_4");
    const fill_3Field = form.getTextField("fill_3");
    const kind1 = form.getTextField("kind1");
    const kind2 = form.getTextField("kind2");
    const fill_6Field = form.getTextField("fill_6");
    const fill_7Field = form.getTextField("fill_7");
    const fill_8Field = form.getTextField("fill_8");
    const fill_9Field = form.getTextField("fill_9");
    const total1 = form.getTextField("total1");
    const total2 = form.getTextField("total2");
    const finalLabel = form.getTextField("finalLabel");

    name1Field.setText(`${data.firstname.trim()} ${data.lastname.trim()}`);
    accountNumberField.setText(data.memberpolicynnbr.trim());
    nikuiNumberField.setText(data.incometaxfilenmbr.toString());
    amitId1Field.setText(data.memberid.trim());
    fundName1Field.setText(getFundText(data.fundname));
    untilDate.setText(pdfDateFormatter(data.dolvaliditydate.trim()));
    fill_1Field.setText("הפקדה לקצבה מזכה");
    fill_2Field.setText(
      `${
        data.endyearnmnlworkerpensprt
          ? numberWithCommas(data.endyearnmnlworkerpensprt)
          : "0"
      }`
    );
    yearDoc.setText(data.dolreportyear.toString())
    yearDoc.setFontSize(13);
    yearDoc.addToPage(firstPage,{
      textColor: rgb(1, 1, 1),
      borderColor: rgb(1, 1, 1),
      borderWidth: 0,
    })
    name2Field.setText(`${data.firstname.trim()} ${data.lastname.trim()}`);
    //policesNumberField.setText("2"); // TBD with Opal... where is this value?
    amitId2Field.setText(data.memberid.trim());
    fundName2Field.setText(getFundText(data.fundname));

    if (data?.selfempdepositsintaxyear && data?.employeddepositsintaxyear) {
      fill_4Field.setText("הפקדה לקצבה - עמית עצמאי");
      fill_3Field.setText(
        `${
          data.selfempdepositsintaxyear
            ? numberWithCommas(data.selfempdepositsintaxyear)
            : "0"
        }`
      );
      kind1.setText("135/180");
      kind2.setText("045/086");
      total1.setText("סה''כ");
      fill_6Field.setText("הפקדה לקצבה - עמית שכיר");
      total2.setText("סה''כ");
      fill_7Field.setText(
        `${
          data.totalselfempdepositsintaxyear
            ? numberWithCommas(data?.totalselfempdepositsintaxyear)
            : "0"
        }`
      );
      fill_8Field.setText(
        `${
          data.employeddepositsintaxyear
            ? numberWithCommas(data.employeddepositsintaxyear)
            : "0"
        }`
      );
      fill_9Field.setText(
        `${
          data.totalemployeddepositsintaxyear
            ? numberWithCommas(data.totalemployeddepositsintaxyear)
            : "0"
        }`
      );
    } else if (data?.selfempdepositsintaxyear) {
      fill_4Field.setText("הפקדה לקצבה - עמית עצמאי");
      fill_3Field.setText(
        `${
          data.selfempdepositsintaxyear
            ? numberWithCommas(data.selfempdepositsintaxyear)
            : "0"
        }`
      );
      kind1.setText("135/180");
      total1.setText("סה''כ");
      fill_7Field.setText(
        `${
          data.totalselfempdepositsintaxyear
            ? numberWithCommas(data?.totalselfempdepositsintaxyear)
            : "0"
        }`
      );
    } else if (data?.employeddepositsintaxyear) {
      fill_4Field.setText("הפקדה לקצבה - עמית שכיר");
      fill_3Field.setText(
        `${
          data.employeddepositsintaxyear
            ? numberWithCommas(data.employeddepositsintaxyear)
            : "0"
        }`
      );
      kind1.setText("045/086");
      total1.setText("סה''כ");
      fill_7Field.setText(
        `${
          data.totalemployeddepositsintaxyear
            ? numberWithCommas(data.totalemployeddepositsintaxyear)
            : "0"
        }`
      );
    }

    finalLabel.setText(getFundText(data.fundname));

    form.updateFieldAppearances(assistantFont);

    // Serialize the PDFDocument to bytes (Base64)
    const pdfBytes = await pdfDoc.saveAsBase64();
    pdfBytes && PdfCreator(pdfBytes); //very good
  }
}

const getFundText = (fundName: string) => {
  const firstIndex = fundName.indexOf("(");
  const secondIndex = fundName.indexOf(")");
  if (firstIndex < 0 || secondIndex < 0) return fundName;

  const fundText = setCharAt(fundName, firstIndex, ")");
  return setCharAt(fundText, secondIndex, "(");
};

const setCharAt = (str: string, index: number, chr: string) => {
  if (index > str.length - 1) return str;
  return str.substring(0, index) + chr + str.substring(index + 1);
};

export default PdfTemplateCreator;
